'use client';
import { useState } from 'react';
import { thumbnailPath } from '@/lib/article-thumbnail';
/** A failed image removes its whole slot; the article text remains readable. */
export default function ArticleThumbnail({ imageKey, href, source, showCaption = true, className = '' }: { imageKey?: string | null; href?: string | null; source?: string | null; showCaption?: boolean; className?: string }) {
  const [failedKey, setFailedKey] = useState<string | null>(null);
  const url = thumbnailPath(imageKey);
  if (!url || imageKey === failedKey) return null;
  let link: string | null = null;
  try { const u = new URL(href || ''); if (['http:', 'https:'].includes(u.protocol) && !u.username && !u.password) link = u.href; } catch { /* non-clickable image */ }
  const content = <>
    {/* eslint-disable-next-line @next/next/no-img-element -- bounded, pre-encoded JPEG cache; no external image optimizer needed. */}
    <img src={url} alt={`${source || '원문 기사'} 대표 이미지`} width={640} height={400} loading="lazy" decoding="async" className="block w-full aspect-[8/5] object-cover rounded-lg" onError={() => setFailedKey(imageKey || null)} />
    {showCaption && <span className="block mt-1 text-xs text-zinc-500 dark:text-zinc-400">원문 이미지{source ? ` · ${source}` : ''}</span>}
  </>;
  return link ? <a href={link} target="_blank" rel="noopener noreferrer" className={className}>{content}</a> : <div className={className}>{content}</div>;
}
